import React, {Dispatch, SetStateAction, useState} from "react";
import Grid from "@mui/material/Grid";
import {Button, Paper, Stack, styled, Typography} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {Icon} from "@iconify/react";
import {Model} from "./Model";
import Box from "@mui/material/Box";
import {AddNewDevice} from "./ModelComponents/AddNewDevice";
import {DeleteDevice} from "./ModelComponents/DeleteDevice";

interface StackRow{
    name : string,
    value : string
}
const StackRow = ({name,value} : StackRow) =>{
    return(
        <Stack alignItems="center">
            <Typography
                fontSize={18}
                color="#089BAB"
                fontWeight={400}
                letterSpacing={1}
            >
                {name}
            </Typography>
            <Typography
                fontSize={15}
                fontWeight={500}
                color="#121A2D"
            >
                {value ? value : "- -"}
            </Typography>
        </Stack>
    )
}

interface readings {
    "mm/Hg" ? : string,
    "mg/dL" ? : string,
    "bpm" ? :string,
    "SPO2" ? :string,
    "temp" ? :string
}

interface DashBoardCardinterface{
    id  : number,
    name  : string,
    Imei : string,
    Category : string,
    setDevices : Dispatch<SetStateAction<any[]>>,
}

export const DeviceCard = ({ Imei , name , Category, id,setDevices } : DashBoardCardinterface ) =>{

    
    const navigate = useNavigate()
    
    const [showDeleteModel,setShowDeleteModel] = useState<boolean>(false)

    const handleOpen = () => setShowDeleteModel(true)
    const handleClose = () => setShowDeleteModel(false)
    
    const getCardData = () =>{

        navigate(`/Dashboard/${Imei}/${Category==="Blood Pressure" ? "bp" : "spo2"}/details/${Category}`)
    }

    const DeleteAlertModel = () =>{
        return(
            <DeleteDevice id={id} imei={Imei} name={name} handleClose={handleClose} setDevices={setDevices} />
        )
    }

    return(
        <Grid item md={10} sm={10} xs={15} xl={3}>
            <Model
                open={showDeleteModel}
                handleClose={handleClose}
                Component = {DeleteAlertModel}
            />
            <Stack spacing={2}  className="card-shadow" padding={3}>

                <Stack onClick={getCardData}>
                    <Typography
                        fontSize={18}
                        fontWeight={500}
                        color="#081735"
                    >
                        Name
                    </Typography>
                    <Typography
                        fontSize={14}
                        fontWeight={300}
                        color="#081735"
                    >
                        {name}
                    </Typography>
                    <Typography
                        fontSize={18}
                        fontWeight={500}
                        color="#081735"
                    >
                        IMEI
                    </Typography>
                    <Typography
                        fontSize={14}
                        fontWeight={500}
                        color="#081735"
                    >
                        {Imei}
                    </Typography>
                    <Typography
                        fontSize={18}
                        fontWeight={500}
                        color="#081735"
                    >
                        Category
                    </Typography>
                    <Typography
                        fontSize={14}
                        fontWeight={500}
                        color="#081735"
                    >
                        {Category}
                    </Typography>
                </Stack>

                <Button
                    onClick={()=>{handleOpen()}}
                    variant="contained"
                    sx={{
                        borderRadius:"16px",
                        background:"#089BAB",
                        textTransform:"none",
                        color:"#F9FAFC",
                        fontWeight:700,
                        padding:1,
                        boxShadow:"none",
                        fontSize : "16px"
                    }}>Delete</Button>
            </Stack>
        </Grid>
    )
}